import absencesTableReducer from "./redux/absencesTable/absencesTable.reducer"
import authenticationReducer from "./redux/authentication/authentication.reducer"
import authorizationReducer from "./redux/authorization/authorization.reducer"
import balanceHoursReducer from "./redux/balanceHours/balanceHours.reducer"
import balanceHoursCorrectionsReducer from "./redux/balanceHoursCorrections/balanceHoursCorrections.reducer"
import codesReducer from "./redux/codes/codes.reducer"
import codesByCategoryReducer from "./redux/codesByCategory/codesByCategory.reducer"
import currentUserReducer from "./redux/currentUser/currentUser.reducer"
import functionReducer from "./redux/functions/functions.reducer"
import notificationsReducer from "./redux/notifications/notifications.reducer"
import personalPlanningReducer from "./redux/personalPlanning/personalPlanning.reducer"
import personalPlanningChannelReducer from "./redux/personalPlanningChannel/personalPlanningChannel.reducer"
import planningAvailabilitiesReducer from "./redux/planningAvailabilities/planningAvailabilities.reducer"
import planningWeekAvailabilitiesReducer from "./redux/planningWeekAvailabilities/planningWeekAvailabilities.reducer"
import planningConflictsReducer from "./redux/planningConflicts/planningConflicts.reducer"
import planningImportReducer from "./redux/planningImport/planningImport.reducer"
import planningTimeslotsReducer from "./redux/planningTimeslots/planningTimeslots.reducer"
import practiceReducer from "./redux/practice/practice.reducer"
import practicesReducer from "./redux/practices/practices.reducer"
import requestReducer from "./redux/requests/requests.reducer"
import rolesReducer from "./redux/roles/roles.reducer"
import shiftsReducer from "./redux/shifts/shifts.reducer"
import tabBarReducer from "./redux/tabbar/tabbar.reducer"
import templatesReducer from "./redux/templates/templates.reducer"
import templateTableReducer from "./redux/templateTable/templateTable.reducer"
import timeslotsReducer from "./redux/timeslots/timeslots.reducer"
import urlReducer from "./redux/url/url.reducer"
import userAbsencesReducer from "./redux/userAbsences/userAbsences.reducer"
import userLeavesReducer from "./redux/userLeaves/userLeaves.reducer"
import usersReducer from "./redux/users/users.reducer"
import usersTableReducer from "./redux/usersTable/usersTable.reducer"
import usersEntitlementsTableReducer from "./redux/userEntitlementsTable/userEntitlementsTable.reducer"
import planningAvailabilitiesTableReducer from "./redux/planningAvailabilitiesTable/planningAvailabilitiesTable.reducer"
import planningWeekAvailabilitiesTableReducer from "./redux/planningWeekAvailabilitiesTable/planningWeekAvailabilitiesTable.reducer"
import preferedHoursReducer from "./redux/preferedHours/preferedHours.reducer"
import templateAvailabilitiesTableReducer from "./redux/templateAvailabilitiesTable/templateAvailabilitiesTable.reducer"
import templateAvailabilitiesReducer from "./redux/templateAvailabilities/templateAvailabilities.reducer"
import weeksReducer from "./redux/weeks/weeks.reducer"
import workstationsReducer from "./redux/workstations/workstations.reducer"
import usersFilterReducer from "./redux/usersFilter/usersFilter.reducer"
import absencesFilterReducer from "./redux/absencesFilter/absencesFilter.reducer"
import availabilitiesFilterReducer from "./redux/availabilitiesFilter/availabilitiesFilter.reducer"
import availabilitiesWeekFilterReducer from "./redux/availabilitiesWeekFilter/availabilitiesWeekFilter.reducer"
import moduleContextReducer from "./redux/moduleContext/moduleContext.reducer"
import templateWeekAvailabilitiesReducer from "./redux/templateWeekAvailabilities/templateWeekAvailabilities.reducer"
import templateWeekAvailabilitiesTableReducer from "./redux/templateWeekAvailabilitiesTable/templateWeekAvailabilitiesTable.reducer"
import templateWeekAvailabilitiesFilterReducer from "./redux/templateWeekAvailabilitiesFilter/templateWeekAvailabilitiesFilter.reducer"
import timeslotsChannelReducer from "./redux/planningTimeslotsChannel/planningTimeslotsChannel.reducer"
import templateTimeslotsChannelReducer from "./redux/templateTimeslotsChannel/templateTimeslotsChannel.reducer"
import workstationAvailabilitiesReducer from "./redux/workstationAvailabilities/workstationAvailabilities.reducer"
import templateWorkstationAvailabilitiesReducer from "./redux/templateWorkstationAvailabilities/templateWorkstationAvailabilities.reducer"
import contractsReducer from "./redux/contracts/contracts.reducer"
import contractsTableReducer from "./redux/contractsTable/contractsTable.reducer"
import planningParamsReducer from "./redux/planningParams/planningParams.reducer"
import hrGeneralLeaveReducer from "./redux/hrGeneralLeaves/hrGeneralLeaves.reducer"
import hrUnavailabilitiesReducer from "./redux/hrUnavailabilities/hrUnavailabilities.reducer"
import hrLeaveEntitlementsReducer from "./redux/hrLeaveEntitlements/hrLeaveEntitlements.reducer"
import hrLeaveEntitlementsTableReducer from "./redux/hrLeaveEntitlementsTable/hrLeaveEntitlementsTable.reducer"
import hrUnavailabilitiesOverviewReducer from "./redux/hrUnavailabilitiesOverview/hrUnavailabilitiesOverview.reducer"

export default {
  absencesFilter: absencesFilterReducer,
  absencesTable: absencesTableReducer,
  authentication: authenticationReducer,
  authorization: authorizationReducer,
  availabilitiesFilter: availabilitiesFilterReducer,
  availabilitiesWeekFilter: availabilitiesWeekFilterReducer,
  balanceHours: balanceHoursReducer,
  balanceHoursCorrections: balanceHoursCorrectionsReducer,
  codes: codesReducer,
  codesByCategory: codesByCategoryReducer,
  contracts: contractsReducer,
  contractsTable: contractsTableReducer,
  currentUser: currentUserReducer,
  functions: functionReducer,
  moduleContext: moduleContextReducer,
  notifications: notificationsReducer,
  personalPlanning: personalPlanningReducer,
  personalPlanningChannel: personalPlanningChannelReducer,
  planningParams: planningParamsReducer,
  planningAvailabilities: planningAvailabilitiesReducer,
  planningAvailabilitiesTable: planningAvailabilitiesTableReducer,
  planningConflicts: planningConflictsReducer,
  planningImport: planningImportReducer,
  planningTimeslots: planningTimeslotsReducer,
  planningTimeslotsChannel: timeslotsChannelReducer,
  planningWeekAvailabilities: planningWeekAvailabilitiesReducer,
  planningWeekAvailabilitiesTable: planningWeekAvailabilitiesTableReducer,
  practice: practiceReducer,
  practices: practicesReducer,
  preferedHours: preferedHoursReducer,
  requests: requestReducer,
  roles: rolesReducer,
  shifts: shiftsReducer,
  tabbar: tabBarReducer,
  templateAvailabilities: templateAvailabilitiesReducer,
  templateAvailabilitiesTable: templateAvailabilitiesTableReducer,
  templates: templatesReducer,
  templateTable: templateTableReducer,
  templateTimeslotsChannel: templateTimeslotsChannelReducer,
  templateWeekAvailabilities: templateWeekAvailabilitiesReducer,
  templateWeekAvailabilitiesFilter: templateWeekAvailabilitiesFilterReducer,
  templateWeekAvailabilitiesTable: templateWeekAvailabilitiesTableReducer,
  templateWorkstationAvailabilities: templateWorkstationAvailabilitiesReducer,
  timeslots: timeslotsReducer,
  url: urlReducer,
  userAbsences: userAbsencesReducer,
  userLeaves: userLeavesReducer,
  users: usersReducer,
  usersEntitlementsTable: usersEntitlementsTableReducer,
  usersFilter: usersFilterReducer,
  usersTable: usersTableReducer,
  weeks: weeksReducer,
  workstations: workstationsReducer,
  workstationAvailabilities: workstationAvailabilitiesReducer,
  hrGeneralLeaves: hrGeneralLeaveReducer,
  hrUnavailabilities: hrUnavailabilitiesReducer,
  hrLeaveEntitlements: hrLeaveEntitlementsReducer,
  hrLeaveEntitlementsTable: hrLeaveEntitlementsTableReducer,
  hrUnavailabilitiesOverview: hrUnavailabilitiesOverviewReducer,
}
